import { PodiumEntry } from "./Types";

export const VideoGamePodium: PodiumEntry[] = [
  {
    name: "Minecraft",
    imgPath: process.env.PUBLIC_URL + "/images/MinecraftLogo.svg",
  },
  {
    name: "Super Paper Mario",
    imgPath: process.env.PUBLIC_URL + "/images/SuperPaperMarioLogo.svg.png",
  },
  {
    name: "Pokémon White",
    imgPath: process.env.PUBLIC_URL + "/images/PokemonWhiteLogo.webp",
  },
];

export const TabletopGamePodium: PodiumEntry[] = [
  {
    name: "Secret Hitler",
    imgPath: process.env.PUBLIC_URL + "/images/SecretHitler.jpg",
  },
  {
    name: "Hanabi",
    imgPath: process.env.PUBLIC_URL + "/images/Hanabi.jpg",
  },
  {
    name: "The Mind",
    imgPath: process.env.PUBLIC_URL + "/images/TheMind.webp",
  },
];
